// Constants and configuration values

export const MATH_JAX_CONFIG = {
    tex: {
        packages: ['base', 'ams'],
    },
};

export const CHAT_LIMITS = {
    MAX_FREE_CHATS: 5,
    PDF_MAX_SIZE: 2 * 1024 * 1024, // 2MB in bytes
    PDF_MAX_PAGES: 10,
    TEXTAREA_MAX_HEIGHT: 100, // pixels
};

export const AUDIO_CONFIG = {
    SAMPLE_RATE: 24000,
    CHANNELS: 1,
    SAMPLE_SIZE: 16,
    ECHO_CANCELLATION: true,
    NOISE_SUPPRESSION: true,
    AUTO_GAIN_CONTROL: false,
    PROCESSOR_BUFFER_SIZE: 4096,
    PING_INTERVAL: 10000, // 10 seconds
    CONNECTION_TIMEOUT: 10000, // 10 seconds
};

export const FILE_TYPES = {
    ALLOWED_IMAGES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
    ALLOWED_DOCUMENTS: ['application/pdf'],
    CSV: 'text/csv',
};

export const MESSAGE_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant',
    ERROR: 'error',
    FUNCTION: 'function',
};

export const FUNCTION_STATES = {
    STARTED: 'started',
    ARGUMENTS: 'arguments',
    EXECUTING: 'executing',
    COMPLETED: 'completed',
};

export const SEARCH_STATES = {
    SEARCHING: 'searching',
    COMPLETED: 'completed',
};

export const STREAM_DATA_TYPES = {
    CHUNK: 'chunk',
    IMAGES: 'images',
    FUNCTION_CALL_STARTED: 'function_call_started',
    FUNCTION_CALL_ARGUMENTS: 'function_call_arguments',
    FUNCTION_EXECUTION_STARTED: 'function_execution_started',
    FUNCTION_EXECUTION_COMPLETED: 'function_execution_completed',
    KNOWLEDGE_BASE_SEARCH_STARTED: 'knowledge_base_search_started',
    KNOWLEDGE_BASE_SEARCH_COMPLETED: 'knowledge_base_search_completed',
    ERROR: 'error',
};

export const WEBSOCKET_MESSAGE_TYPES = {
    AUTHENTICATE: 'authenticate',
    AUTHENTICATED: 'authenticated',
    AUTHENTICATION_FAILED: 'authentication_failed',
    CLEAR_AUDIO_QUEUE: 'clear_audio_queue',
    AUDIO_RESPONSE: 'audio_response',
    TRANSCRIPTION: 'transcription',
    CONVERSATION_STOPPED: 'conversation_stopped',
    RESPONSE_CANCELED: 'response.canceled',
    PING: 'ping',
    PONG: 'pong',
    CLIENT_DISCONNECT: 'client_disconnect',
};

export const CHART_COLORS = {
    BACKGROUND: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)',
        'rgba(255, 159, 64, 0.6)',
        'rgba(255, 205, 86, 0.6)',
        'rgba(201, 203, 207, 0.6)',
        'rgba(255, 99, 71, 0.6)'
    ],
    BORDER: [
        'rgb(255, 99, 132)',
        'rgb(54, 162, 235)',
        'rgb(75, 192, 192)',
        'rgb(153, 102, 255)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(201, 203, 207)',
        'rgb(255, 99, 71)'
    ],
};

export const CHART_TYPE_MAPPING = {
    'bar': 'bar',
    'scatter': 'line',
    'line': 'line',
    'pie': 'pie',
    'histogram': 'bar',
    'box': 'boxplot',
    'violin': 'violin',
    'heatmap': 'heatmap',
    'contour': 'line',
    'scatterpolar': 'radar',
    'scattergeo': 'line',
    'scatter3d': 'scatter',
    'surface': 'line'
};

export const DISCLAIMER_EXPIRY_DAYS = 7;

export const SCROLL_BEHAVIOR = {
    SCROLL_THRESHOLD: 50, // pixels from bottom to consider "at bottom"
    SCROLL_TIMEOUT: 2000, // milliseconds to wait before resetting scroll state
    AUTO_SCROLL_DELAY: 100, // milliseconds delay for auto-scroll
};

export const TYPING_ANIMATION = {
    STREAMING_SPEED: 15, // milliseconds per character for streaming effect
    DOTS_ANIMATION_DELAY: [0, 100, 200], // milliseconds delay for each typing dot
};

export const LOCAL_STORAGE_KEYS = {
    AUTH_TOKEN: 'authToken',
    ACCESS_TOKEN: 'access_token',
    FREE_CHAT_COUNT: 'geoHubFreeChatCount',
    DISCLAIMER_SEEN: 'hasSeenDisclaimer',
    THEME: 'theme',
    LANGUAGE: 'language',
    FONT_SIZE: 'fontSize',
};

export const SESSION_STORAGE_KEYS = {
    FROM_CHAT_LIMIT: 'fromChatLimit',
};

export const EXTERNAL_LINKS = {
    PRIVACY_POLICY: 'https://www.encardio.com/privacy-policies',
    FEEDBACK_FORM: 'https://forms.office.com/r/gp2dd1xEA5?origin=lprLink',
    PDF_JS_CDN: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.min.js',
    PDF_WORKER_CDN: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js',
};

export const MODE_TYPES = {
    KNOWLEDGE: 'knowledge',
    SUPPORT: 'support',
    GRAPHING: 'graphing',
    TOOLS: 'tools',
};

export const CHART_MODES = {
    GENERATE: 'generate',
    ANALYZE: 'analyze',
};

export const PRODUCT_CODE_PATTERNS = [
    /\b([A-Z]{2,4})-(\d{1,3})([A-Z]?)\b/g,
    /\b([A-Z]{2,4})(\d{1,3})([A-Z]?)\b/g,
    /\b([A-Z]{2,4})[- ](\d{1,3})[- ]?([A-Z]?)[- ]?([A-Z0-9-]*)\b/g,
]; 